import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnpaidRoutingModule } from './unpaid-routing.module';
import { UnpaidComponent } from './unpaid/unpaid.component';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { UnpaidDataComponent } from './unpaid-data/unpaid-data.component';
import { UnpaidDataTableComponent } from './unpaid-data-table/unpaid-data-table.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UnpaidHeaderComponent } from './unpaid-header/unpaid-header.component';
import { UnpaidSummaryComponent } from './unpaid-summary/unpaid-summary.component';
import { UnpaidFiltersComponent } from './unpaid-filters/unpaid-filters.component';
import { UnpaidFilterDialogComponent } from './unpaid-filter-dialog/unpaid-filter-dialog.component';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReactiveFormsModule } from '@angular/forms';
import { UnpaidSetNoteDialogComponent } from './unpaid-set-note-dialog/unpaid-set-note-dialog.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [
    UnpaidComponent,
    UnpaidDataComponent,
    UnpaidDataTableComponent,
    UnpaidHeaderComponent,
    UnpaidSummaryComponent,
    UnpaidFiltersComponent,
    UnpaidFilterDialogComponent,
    UnpaidSetNoteDialogComponent,
  ],
  imports: [
    CommonModule,
    UnpaidRoutingModule,
    NavbarModule,
    ToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    SharedModule,
    TranslateModule,
    LoadingModule,
    MatTooltipModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
  ],
})
export class UnpaidModule {}
